var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6548 10.6924C11.1856 10.6924 11.6164 10.2616 11.6164 9.73083C11.6164 9.20006 11.1856 8.76929 10.6548 8.76929C10.1241 8.76929 9.69328 9.20006 9.69328 9.73083C9.69328 10.2616 10.1241 10.6924 10.6548 10.6924ZM6.80773 12.6154C7.3385 12.6154 7.76927 12.1847 7.76927 11.6539C7.76927 11.1231 7.3385 10.6924 6.80773 10.6924C6.27696 10.6924 5.84619 11.1231 5.84619 11.6539C5.84619 12.1847 6.27696 12.6154 6.80773 12.6154Z",
    fill: "#2B2B2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0769 26.0769L15.4615 26.0769L16.6154 19.3461L24.1154 19.3461L25.0769 26.0769Z",
    stroke: "#2B2B2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2693 19.3462V4.9231",
    stroke: "#2B2B2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9231 14.5385H13.5385L11.6154 26.0769H5.84617L3.9231 14.5385Z",
    fill: "#2B2B2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9231 14.5385V14.0385C3.77612 14.0385 3.63659 14.1031 3.54159 14.2153C3.44658 14.3274 3.40574 14.4757 3.4299 14.6207L3.9231 14.5385ZM13.5385 14.5385L14.0317 14.6207C14.0558 14.4757 14.015 14.3274 13.92 14.2153C13.825 14.1031 13.6855 14.0385 13.5385 14.0385V14.5385ZM11.6154 26.0769V26.5769C11.8598 26.5769 12.0684 26.4002 12.1086 26.1591L11.6154 26.0769ZM5.84617 26.0769L5.35298 26.1591C5.39316 26.4002 5.60175 26.5769 5.84617 26.5769V26.0769ZM3.9231 15.0385H13.5385V14.0385H3.9231V15.0385ZM13.0453 14.4563L11.1222 25.9947L12.1086 26.1591L14.0317 14.6207L13.0453 14.4563ZM11.6154 25.5769H5.84617V26.5769H11.6154V25.5769ZM6.33937 25.9947L4.41629 14.4563L3.4299 14.6207L5.35298 26.1591L6.33937 25.9947Z",
    fill: "#2B2B2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3462 26.0769V24.1538",
    stroke: "#2B2B2C",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2693 26.0769V24.1538",
    stroke: "#2B2B2C",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1923 26.0769V24.1538",
    stroke: "#2B2B2C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVask);
export default __webpack_public_path__ + "static/media/Vask.4e7e7f4125acc1d007f52fbfab26e345.svg";
export { ForwardRef as ReactComponent };